import { OWebPageBase, tPageRoute } from "oweb";
import PUserPicEditComponent from "@/components/pages/oweb/PUserPicEdit.vue";
import { VueConstructor } from 'vue';

export default class PUserPicEdit extends OWebPageBase<VueConstructor> {
	getName() {
		return "PUserPicEdit"
	}

	getRoutes(): tPageRoute[] {
		return [ {
			title: "OO_LANG_USER_PROFILE_PIC",
			path: "/me/edit/pic"
		}, {
			title: "OO_LANG_GROUP_PIC",
			path: "/groups/:groupId/edit/pic",
			pathOptions: {
				groupId: "num"
			}
		} ]
	}

	requireLogin() {
		return true;
	}

	getComponent() {
		return PUserPicEditComponent;
	}
}